module.exports = __webpack_public_path__ + "static/media/maintainance.2c03bd15.svg";